import { render, staticRenderFns } from "./SubmitReplacements.vue?vue&type=template&id=d4127e2c&"
import script from "./SubmitReplacements.vue?vue&type=script&lang=js&"
export * from "./SubmitReplacements.vue?vue&type=script&lang=js&"
import style0 from "./SubmitReplacements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports